import { useCallback } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

type UseApiAccessTokenOptions = {
  returnTo?: string;
};

const API_AUDIENCE = 'https://odp.golf/audience';
const API_SCOPE = 'openid profile email offline_access';

export const useApiAccessToken = (options: UseApiAccessTokenOptions = {}) => {
  const { getAccessTokenSilently, loginWithRedirect } = useAuth0();

  return useCallback(async (): Promise<string> => {
    try {
      return await getAccessTokenSilently({
        authorizationParams: {
          audience: API_AUDIENCE,
          scope: API_SCOPE,
        },
      });
    } catch (error: any) {
      const message = String(error?.message || '');
      if (message.includes('Missing Refresh Token') || message.includes('refresh_token')) {
        await loginWithRedirect({
          authorizationParams: {
            audience: API_AUDIENCE,
            scope: API_SCOPE,
            prompt: 'login',
          },
          appState: options.returnTo ? { returnTo: options.returnTo } : undefined,
        });
      }
      throw error;
    }
  }, [getAccessTokenSilently, loginWithRedirect, options.returnTo]);
};

